import create from 'zustand';

import { DEFAULT_MISSING_EMAIL, DEFAULT_USER_CURRENCY, LANG_ES } from '@/config/appConstants';
import { Appsumo, Capabilities, GroupInfo, Me, UserInfo } from '@/types';

type MeHook = {
  me: Me;
  isSet: boolean;
  getMe: () => Me;
  setMe: (me: Me) => void;
  isMeSet: () => boolean;
  setUserInfo: (userInfo: UserInfo) => void;
  setGroupInfo: (groupInfo: GroupInfo) => void;
  setCapabilities: (capabilities: Capabilities) => void;
};

const defaultUserInfo: UserInfo = {
  id: '',
  name: '',
  lastName: '',
  email: DEFAULT_MISSING_EMAIL,
  rolId: '',
  language: LANG_ES,
};

const defaultGroupInfo: GroupInfo = {
  id: '',
  name: '',
  createdAt: '',
  plan: '',
  countryId: '',
  currency: DEFAULT_USER_CURRENCY,
};

const defaultAppsumo: Appsumo = {
  isAppsumo: false,
  canMakeAppsumoActions: false,
};

const defaultCapabilities: Capabilities = {
  isManualValidationEnabled: true,
  isBillingDetailsFilled: false,
  canBuySubscriptionProducts: false,
  canBuyProducts: false,
  apiAccessEnabled: false,
  appsumo: defaultAppsumo,
  chatbaseToken: '',
  isEmBlue: false,
};

const defaultMe: Me = {
  userInfo: defaultUserInfo as UserInfo,
  groupInfo: defaultGroupInfo as GroupInfo,
  capabilities: defaultCapabilities as Capabilities,
} as Me;

export const useMe = create<MeHook>((set, get) => ({
  me: defaultMe,
  isSet: false,
  getMe: (): Me => {
    return {
      userInfo: get().me.userInfo,
      groupInfo: get().me.groupInfo,
      capabilities: get().me.capabilities,
    };
  },

  setMe: (me: Me) => {
    if (
      me.userInfo === get().me?.userInfo &&
      me.groupInfo === get().me?.groupInfo &&
      me.capabilities === get().me?.capabilities
    )
      return;
    set(() => ({
      isSet: true,
      me: me,
    }));
  },

  isMeSet: (): boolean => {
    return get().isSet;
  },

  setUserInfo: (userInfo: UserInfo) => {
    if (userInfo === get().me?.userInfo) return;
    const me = get().me;
    if (me) me.userInfo = userInfo;
    set(() => ({
      me: me,
    }));
  },

  setGroupInfo: (groupInfo: GroupInfo) => {
    if (groupInfo === get().me?.groupInfo) return;
    const me = get().me;
    if (me) me.groupInfo = groupInfo;
    set(() => ({
      me: me,
    }));
  },

  setCapabilities: (capabilities: Capabilities) => {
    if (capabilities === get().me?.capabilities) return;
    const me = get().me;
    if (me) me.capabilities = capabilities;
    set(() => ({
      me: me,
    }));
  },
}));
